import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import './App.css';
import Modal from './components/styles/Modal';
import styled from 'styled-components';

const Button = styled.button`
  border: 2px solid ${props => props?.widgetData?.borderColor || 'white'};
  border-radius: 8px;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  width: 100%;
  background-color: ${props => props?.widgetData?.primaryColor || '#ffa600'};
  color: white;
  color: ${props => props?.widgetData?.textColor || 'white'};
  cursor: pointer;
`;

const AppContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 600px;
  width: 100%;
`;

function App(props) {

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-K9GRMN6",
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  const widgetDataObj = JSON.parse(JSON.stringify({ ...props.domElement.dataset }));
  const widgetData = JSON.parse(widgetDataObj['widgetdata']);
  let url = "https://app.gorillaroofleads.com/home?dealer_unique_id=" + widgetData.dealer_unique_id

  //<Home widgetData={widgetData}></Home>
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <AppContent>
      <Button widgetData={widgetData} onClick={openModal}>Get Roof Estimate</Button>
      <Modal 
        show={showModal} 
        onClose={closeModal}
        title=""
      >
        <iframe title="Roof Lead" src={url} width="100%" height="100%" style={{ border: 'none', borderRadius: '5px' }}>
          Your browser does not support iframes.
        </iframe>   
      </Modal>
    </AppContent>
  );
}

export default App;
